/** @format */

const ChooseUs = ({ onRegisterClick }) => {
  return (
    <>
      <div>
        <div>
          <h2>Why Attend This Training?
</h2>
<p>Discover how we evaluate investment properties in real time using the exact strategies our top students rely on to find, flip, and build long-term wealth.

</p>
<div className="video-container">
      <iframe
        src="https://player.vimeo.com/video/1082327273?app_id=122963&autoplay=0&controls=1"
        title="Vimeo player"
        allow="autoplay; fullscreen"
        allowFullScreen
      ></iframe>
    </div>
    
            </div>
     
      </div>
 
      <button
        type="button"
        onClick={onRegisterClick}
        className="about-us-btn"
      >
        Register For The Free Event
      </button>
    </>
  );
};

ChooseUs.defaultProps = {
  onRegisterClick: () => {},
};

export default ChooseUs;
